import styled from 'styled-components';

export const Wrapper = styled.div`
    flex-direction: row;
    flex-wrap: nowrap;
    width: 100%;
    gap: 12px;
`;

export const IconWrapper = styled.div`
    flex-basis: 24px;
`;

export const TextWrapper = styled.div`
    flex-direction: column;
    justify-content: center;
    align-self: flex-start;
    gap: 4px;
`;
